import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import { Divider, Typography } from '@mui/material'
import Item from './item'
import ManualFulfillment from './ManualFulfillment';

const OrderItems = props => (
  <Grid container>
    <Grid container size={12} alignItems="center" justifyContent="space-between" sx={{ marginBottom: 2, paddingLeft: '3%', paddingRight: '3%', paddingTop: '3%' }}>
      <Typography variant="h5">Order Items</Typography>
      <ManualFulfillment order={props.order} />
    </Grid>
    <Divider width="100%" />
    <Grid size={12}>
      {props.order_items.map(order_item => {
          const fulfillmentCenter = props.orderFulfillments.find(f => f.productIds.includes(order_item.product.id))
          return ( <React.Fragment key={order_item.id}> <Item {...order_item} order={props.order} storeCurrency={props.storeCurrency} fulfillmentCenter={fulfillmentCenter} order_item_id={order_item.id} refundItems={props.order.refunds.flatMap(refund => refund.refund_items)} /> <Divider width="100%" /> </React.Fragment > ) })
      }
    </Grid>
  </Grid>
)

OrderItems.propTypes = {
  order_items: PropTypes.array.isRequired,
  order: PropTypes.shape({
    discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    coupon: PropTypes.object,
    freight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    store: PropTypes.object,
    net_total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    use_account_balance: PropTypes.bool,
    balance_used: PropTypes.string
  }),
  storeCurrency: PropTypes.object.isRequired
}

export default OrderItems